import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/SiteManagement/Form/SiteAuditIndex/index'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import {
    v2_ships,
} from '../../../actions/v2/projectAndVessel';
import { v3_fetchNewBuildingSiteAuditIndex, v3_fetchNewBuildingSiteQueryReportIndexFields, v3_submitNewBuildingSiteAuditIndex, v3_submitNewBuildingSiteQueryReportIndex } from '../../../actions/v3/siteManagement';
import { v2_yards } from '../../../actions/v2/masterData';

const NewBuildingBlockInspectionStatus = (props) => {

    const location = useLocation();
    const { data } = location.state || {};
    // 1. Rename state to items (flat list)

    const defaultRow = {
        date_audited: { name: 'date_audited', value: '', error: '', isRequired: true },
        ship: { name: 'ship', value: '', options: [], error: '', isRequired: true },
        owner: { name: 'owner', value: '', error: '', isRequired: true },
    };

    const [state, setState] = useState([defaultRow]);
    const handleChange = (field, value, index = 0) => {
        setState(prevState => {
            const updatedState = [...prevState];
            updatedState[index][field] = {
                ...updatedState[index][field],
                value,
                error: '',
            };
            return updatedState;
        });
    };

    const addRow = () => {
        setState(prev => {
            const shipOptions = prev[0]?.ship?.options || [];
            const newRow = {
                ...JSON.parse(JSON.stringify(defaultRow)),
                ship: { ...defaultRow.ship, options: shipOptions }
            };
            return [...prev, newRow];
        });
    };


    const removeRow = (indexToRemove) => {
        setState(prev => prev.filter((_, i) => i !== indexToRemove));
    };


    const [showLoader, setShowLoader] = useState(false);

    // Load ships when yard changes
    useEffect(() => {
        v2_ships(null, null, null).then((res) => {
            if (res.status) {
                const shipOptions = res.result;

                setState((prevState) =>
                    prevState.map((row) => ({
                        ...row,
                        ship: {
                            ...row.ship,
                            options: shipOptions,
                        },
                    }))
                );
            }
        });
    }, []);


    useEffect(() => {
        setShowLoader(true);

        v3_fetchNewBuildingSiteAuditIndex(
        )
            .then((res) => {
                if (res.status) {
                    
                    // convert flat records to form model
                    const mappedItems = res.result.map((item) => {
                        return {
                            entryId: item.ID,
                            date_audited: {
                                ...defaultRow.date_audited,
                                value: item.DATE_AUDITED || '',
                            },
                            ship: {
                                ...defaultRow.ship,
                                value: item.SHIP_ID || '',
                            },
                            owner: {
                                ...defaultRow.owner,
                                value: item.OWNER_NAME,
                            },

                        };
                    });
                    // set state (renamed from state to items if needed)
                    setState(mappedItems);
                } else {
                    toast.error(res.error);
                }
            })
            .catch(() => toast.error('Something went wrong while fetching.'))
            .finally(() => setShowLoader(false));

    }, []);

    const onSubmit = async () => {
        // 1. Validation
        const errors = [];

        // Validate each row
        state.forEach((row, index) => {
            Object.entries(row).forEach(([key, field]) => {
                if (key === 'entryId') return; // Skip entryId

                const isRequired = field.isRequired  // Enforce all fields if finalSubmit is true
                if (isRequired && !field.value) {
                    errors.push(`Row ${index + 1}: ${key.replace(/_/g, ' ')} is required.`);
                }
            });
        });


        if (errors.length > 0) {
            toast.error(errors.join('\n'));
            return;
        }
        // If final submit is true, confirm before proceeding



        // 2. Build checklistItems payload
        const checklistItems = state.map((row) => {
            const formattedRow = {};
            Object.keys(row).forEach((key) => {
                formattedRow[key.toUpperCase()] = row[key].value;
            });
            if (row['entryId']) {
                formattedRow.ID = row['entryId']
            }
            return formattedRow;
        });

        // 3. Build full payload
        const payload = {
            checklistItems,
        };

        // 4. Submit
        setShowLoader(true);
        v3_submitNewBuildingSiteAuditIndex(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(constant.Authedcomponent.siteManagement.url);
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };
    useEffect(() => {
        const updatedState = state.map((row) => {
            const selectedShip = row.ship.options.find(
                (ship) => ship.ID == row.ship.value
            );

            const currentOwner = row.owner?.value || '';

            if (selectedShip?.OWNER_NAME && selectedShip.OWNER_NAME !== currentOwner) {
                return {
                    ...row,
                    owner: {
                        ...row.owner,
                        value: selectedShip.OWNER_NAME
                    }
                };
            }

            return row;
        });

        // Only update state if it's actually changed to avoid infinite loop
        const isChanged = updatedState.some((row, i) => row.owner.value !== state[i].owner.value);
        if (isChanged) {
            setState(updatedState);
        }
    }, [
        // Track just the ship values as dependencies
        ...state.map((row) => row.ship.value)
    ]);



    return (
        <Layout title="Site Query Report Index">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>Site Audit Index (Site manager's Report)
                                            </h4>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Form
                                onChange={handleChange}
                                state={state}
                                onSubmit={onSubmit}
                                addRow={addRow}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus